import { defineMessages } from 'react-intl';

export default defineMessages({
    policyDetails: {
        id: "common.directives.ml-confirmation-policy-details-box.POLICY DETAILS",
        defaultMessage: "POLICY DETAILS"
    },
    policyNumber: {
        id: "common.directives.ml-confirmation-policy-details-box.Policy",
        defaultMessage: "Policy #{policyNumber}"
    },
    effectiveDate: {
        id: "common.directives.ml-confirmation-policy-details-box.Eff date",
        defaultMessage: "Effective Date of {changeType}: {date}"
    },
    expirationDate: {
        id: "common.directives.ml-confirmation-policy-details-box.Exp date",
        defaultMessage: "Expiration Date of {changeType}: {date}"
    },
    amount: {
        id: "common.directives.ml-confirmation-policy-details-box.Amount",
        defaultMessage: "Amount of {changeType}: {amount}"
    },
    paymentMethod: {
        id: "common.directives.ml-confirmation-policy-details-box.Payment Method",
        defaultMessage: "Payment Method:"
    },
    endingIn: {
        id: "common.directives.ml-confirmation-policy-details-box.Ending In",
        defaultMessage: "Ending in {endingIn}"
    },
    paymentSchedule: {
        id: "common.directives.ml-confirmation-policy-details-box.Payment Schedule",
        defaultMessage: "Payment Schedule: {paymentSchedule}"
    },
    insured: {
        id: "common.directives.ml-confirmation-policy-details-box.INSURED",
        defaultMessage: "INSURED"
    },
    coInsured: {
        id: "common.directives.ml-confirmation-policy-details-box.CO-INSURED",
        defaultMessage: "CO-INSURED"
    }
});
